export default "__VITE_ASSET__pO2IYik3__"